import { Box, createStyles, Grid, makeStyles, Paper } from '@material-ui/core';
import { ArrowsChevronSmallRight, ExtendedTheme, Link, TextBlock } from 'neon-design-system';
import React from 'react';
import { ChannelSubscriptionWithPaymentInfo } from '../../../shared/types';
import { baseUrls } from '../../../utils/baseUrls.utils';
import ChannelSubscriptionCard from './ChannelSubscriptionCard';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) => createStyles({
	link: {
		display: 'flex',
		alignItems: 'center',
		fontWeight: 'bold'
	},
	linkIcon: {
		width: 14,
		marginLeft: theme.spacing(0.5)
	},
	cardWrapper: {
		display: 'flex'
	}
}));

interface SubscriptionsChannelsProps {
	channelSubscriptions: ChannelSubscriptionWithPaymentInfo[];
	onUpdate: () => void;
}

export const ChannelSubscriptionCards = ({ channelSubscriptions, onUpdate }: SubscriptionsChannelsProps) => {
	const classes = useStyles();
	if (channelSubscriptions.length === 0) {
		return <Paper>
			<Box p={3} display="flex" justifyContent="space-between" alignItems="center">
				<TextBlock>You do not have any subscriptions.</TextBlock>
				<Link to={baseUrls.channels.main} className={classes.link}>Browse Channels <ArrowsChevronSmallRight className={classes.linkIcon} /></Link>
			</Box>
		</Paper>;
	}

	return <>
		<Grid container spacing={2}>
			{channelSubscriptions.map(cs =>
				<Grid key={cs.channel._id} item xs={12} md={4} className={classes.cardWrapper}>
					<ChannelSubscriptionCard subscription={cs} onUpdate={onUpdate} />
				</Grid>)}
		</Grid>
	</>
}
